<template>
  <div class="flex py-4 flex-wrap">
    <div class="w-6/12 justify-start flex">
      <div class="table__search-input-wrapper w-[400px] opacity-75">
        <span class="pr-2 opacity-50"><search-icon /> </span>

        <input
          type="text"
          class="table__search-input"
          placeholder="Search..."
          v-model="searchString"
        />
        <img
          @click="showFilterModal = true"
          class="cursor-pointer"
          src="@/assets/images/icons/search.svg"
          alt="search icon"
        />
      </div>
    </div>
    <div class="date-picker w-6/12 flex items-center justify-end">
      <el-date-picker
        type="date"
        placeholder="Start Date"
        style="margin: 0"
        class="mr-3"
        v-model="startDate"
      />
      <span class="pr-2 opacity-50"> to </span>
      <el-date-picker
        type="date"
        placeholder="End Date"
        style="margin: 0"
        v-model="endDate"
      />
    </div>

    <div class="w-full flex justify-end mt-3">
      <button class="py-2 w-24 bg-primary-yellow" hidden>settle</button>
    </div>
    <filter-table-settlement
      :show-modal="showFilterModal"
      @close-modal="showFilterModal = false"
    />
  </div>
</template>

<script>
import FilterTableSettlement from "../modals/FilterTableSettlement.vue";

export default {
  components: {
    FilterTableSettlement,
  },
  computed: {
    sortProps() {
      return {
        startDate: this.startDate || null,
        endDate: this.endDate || null,
        searchString: this.searchString,
      };
    },
  },
  watch: {
    sortProps() {
      if ((this.startDate && this.endDate) || this.searchString.trim()) {
        this.$emit("setQueryparams", this.sortProps);
      }
    },
  },
  // setQueryparams
  data() {
    return {
      showFilterModal: false,
      startDate: "",
      endDate: "",
      searchString: "",
    };
  },
};
</script>

<style lang="scss" scoped></style>
